import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { finalizeLoader, GuiFacade } from '@app/store/gui';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { voivodeshipListActions } from '../actions/voivodeship-list.actions';
import { HttpService } from '../services/http.service';

@Injectable()
export class VoivodeshipListEffects {
    private readonly actions$ = inject(Actions);
    private readonly httpService = inject(HttpService);
    private readonly guiFacade = inject(GuiFacade);

    getVoivodeship$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(voivodeshipListActions.getVoivodeshipList),
            switchMap(() =>
                this.httpService.getVoivodeship().pipe(
                    map((payload) => voivodeshipListActions.getVoivodeshipListSuccess({ payload })),
                    catchError((error: HttpErrorResponse) => of(voivodeshipListActions.getVoivodeshipListError({ code: error.status }))),
                    finalizeLoader(this.guiFacade, 'voivodeships-get'),
                ),
            ),
        );
    });
}
